import { useStateMachine } from "little-state-machine"
import { useIntl } from "react-intl"
import { updateAction } from "utils/littleStateMachine"
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"
import { useForm } from "react-hook-form"
import { VALIDATION_MESSAGES } from "utils/forms"
import InputTextArea from "components/InputMUI/TextArea"
import { GENERIC_MSGS } from "modules/claims/constants"
import { BUTTON_MESSAGES } from "utils/buttons"
import ProgressBar from "modules/claims/components/StepForm/ProgressBar"
import RadioButton from "components/InputMUI/RadioButton"
import { DIFFERENCES_IN_HAND_MSGS, DIFFERENCES_OPTIONS } from "./constants"
import { useNavigate } from "react-router-dom"
import { redirectToNextStep } from "../../../utils"

const DifferencesInHand = () => {
  const intl = useIntl()
  const navigate = useNavigate()
  const { actions, state } = useStateMachine({ updateAction })

  const defaultValues = { ...state }
  const schema = yup.object({
    describeTheDifference: yup.string().required(intl.formatMessage(VALIDATION_MESSAGES.required)),
    howDetectDifference: yup.string().required(intl.formatMessage(VALIDATION_MESSAGES.required)),
    howAffectsDifference: yup.string().required(intl.formatMessage(VALIDATION_MESSAGES.required))
  })

  const {
    control,
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    defaultValues,
    resolver: yupResolver(schema)
  })

  const onSubmit = (data) => {
    actions.updateAction(data)
    redirectToNextStep(navigate)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <RadioButton
        name="describeTheDifference"
        register={register}
        label={DIFFERENCES_IN_HAND_MSGS.describeTheDifference}
        options={DIFFERENCES_OPTIONS}
        defaultValue={state.describeTheDifference}
        error={errors.describeTheDifference?.message}
      />
      <InputTextArea
        name="howDetectDifference"
        control={control}
        label={DIFFERENCES_IN_HAND_MSGS.howDetectDifference}
        placeholder={GENERIC_MSGS.typeAnswer_placeholder}
        defaultValue={state.howDetectDifference}
        error={errors.howDetectDifference?.message}
      />
      <InputTextArea
        name="howAffectsDifference"
        control={control}
        label={DIFFERENCES_IN_HAND_MSGS.howAffectDifference}
        placeholder={GENERIC_MSGS.typeAnswer_placeholder}
        defaultValue={state.howAffectsDifference}
        error={errors.howAffectsDifference?.message}
      />
      <div className="btn-container">
        <button className="btn btn-dark" type="submit">
          {intl.formatMessage(BUTTON_MESSAGES.ok)}
        </button>
      </div>
      <ProgressBar
        progress={60}
        handleNext={handleSubmit(onSubmit)}
        RoutePrev={state.previousStep}
      />
    </form>
  )
}

export default DifferencesInHand
